import { gql } from 'apollo-boost';
import SplashScreen from 'components/organisms/SplashScreen';
import { useStoryblok } from 'hooks/useStoryblok';
import RenderItemStoryblok from '../../RenderItemStoryblok/Education';
import { Helmet } from 'react-helmet';
import { useDisplayedNews } from 'providers/generalContext';
import { useEffect } from 'react';

const query = gql`
    {
        PageItem(id: "educacao/", resolve_relations: "custom_article.article") {
            content {
                body
                seo
            }
        }
    }
`;

const newsComponents = ['main_news', 'checked_news_education'];

function EducationTemplate() {
    const resolveRelations = ['custom_article.article'];
    const { story, loading } = useStoryblok(query, 'PageItem', resolveRelations);

    const title = story?.content?.seo?.title;
    const description = story?.content?.seo?.description;
    const { setDisplayedNews } = useDisplayedNews();

    useEffect(() => {
        if (!loading && story) {
            story.content.body.forEach((item, index) => {
                if (newsComponents.includes(item.component)) {
                    setDisplayedNews(oldState => ({
                        ...oldState,
                        [index]: {
                            componentHasNews: true,
                            ...oldState[index]
                        }
                    }));
                }
            });
        }
    }, [loading, story]);

    return (
        <>
            <Helmet>
                <title>{title || 'Lupa | Educação'}</title>

                <meta property="og:title" content={title || 'Lupa | Educação'} />
                <meta
                    property="og:description"
                    content={
                        description ||
                        'Conheça o trabalho de checagem de fatos, dados e declarações feito pela Agência Lupa'
                    }
                />
                <meta property="og:url" content="https://lupa.uol.com.br/educacao" />
                <meta
                    property="og:image"
                    key="og:image"
                    content="https://a.storyblok.com/f/134103/200x200/74c63f4833/logo200x200.png"
                />
                <meta name="twitter:card" content="summary_large_image" />
                <link rel="canonical" href="https://lupa.uol.com.br/educacao" />
            </Helmet>
            {!loading && story ? (
                story?.content?.body?.map((educationItem, index) => (
                    <div key={educationItem._uid}>{RenderItemStoryblok({ ...educationItem, index })}</div>
                ))
            ) : (
                <SplashScreen />
            )}
        </>
    );
}

export default EducationTemplate;
